import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import ContactRequestsDetail from "../../ContactRequestsDetail";
import './styles.scss';

class ContactRequests extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {
    const { buttonLabel, className } = this.props;
    const { modal } = this.state;
    return (
      <React.Fragment>
        <a className="dropdown-menu-link" onClick={this.toggle}>
          {buttonLabel}
        </a>
        <Modal
          isOpen={modal}
          toggle={this.toggle}
          className={className}
          size="md"
        >
          <ModalBody className="contact-requests-modal-body">
            <ContactRequestsDetail toggleModal={this.toggle} showClose={true}/>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

export default ContactRequests;



// WEBPACK FOOTER //
// ./src/components/modals/ContactRequestsModal/ContactRequests.jsx